// aiShadowMixin.js
import api from '@/store/api'

export default {
  data() {
    return {
      aiSession: '',
      aiCurrentTurn: null,
      aiCurrentFeedback: null,
      isAiTeacherLoading: false,
      isAiFeedbackLoading: false
    };
  },
  methods: {
    /**
     * 處理錄音完畢、拿到 ERS 解析結果後的核心動作
     */
    async processErsResult (digest, targetEn, categoryContext) {
      this.aiCurrentFeedback = null;

      // 1. 準備 ② Teacher 的 Payload
      const teacherPayload = {
        content: targetEn,
        session: this.aiSession,
        ers: digest,
        ...categoryContext
      };

      // 2. 準備 ④ Feedback 的 Payload  (純文字 summary)
      const summaryText = this.buildErsSummaryText (digest, targetEn);
      const feedbackPayload = { content: summaryText };

      // 3. 並行觸發兩個 API，互不阻擋
      this.fetchTeacherTurn (teacherPayload)
      this.fetchFeedback (feedbackPayload, digest)
    },
    /**
     * 內部方法：打 ④ Feedback 端點  (Best-effort，失敗則 fallback)
     */
    async fetchFeedback (payload, digest) {
      this.isAiFeedbackLoading = true;
      try {
        const res = await api.post('/ai/generate/6c9d59dc-40a3-4e1b-854a-120bb399d2bf', payload);

        const responseData = res.data || {};
        const parsedFeedback = this.parseAiResult(responseData.result);


        if (!parsedFeedback.overall && (!parsedFeedback.tips || parsedFeedback.tips.length === 0)) {
          this.aiCurrentFeedback = this._generateFallbackTips(digest);
        } else {
          this.aiCurrentFeedback = parsedFeedback;
        }
      } catch (error) {
        console.warn('Feedback API Failed, using client fallback.', error);
        this.aiCurrentFeedback = this._generateFallbackTips(digest);
      } finally {
        this.isAiFeedbackLoading = false;
      }
    },

    // ---------------- 工具方法 ----------------

    parseAiResult (resultStr) {
    if (!resultStr) return null; // 👈 這裡原本是 {}，改成 null
    try {
        const cleanStr = resultStr.replace(/```json/g, '').replace(/```/g, '').trim();
        return JSON.parse(cleanStr);
    } catch (e) {
        console.error('JSON Parse Error', e);
        return null; // 👈 這裡原本也是 {}，改成 null
    }
    },

    _coerceTargetRole (turn) {
      if (turn && turn.target && turn.target.en && turn.lines) {
        const hasTarget = turn.lines.some(l => l.role === 'target' || l.role === 'correction');
        if (!hasTarget) {
          const targetLine = turn.lines.find(l => l.en === turn.target.en);
          if (targetLine) {
            targetLine.role = turn.stage === 'correction' ? 'correction' : 'target';
          }
        }
      }
      return turn;
    },

    buildErsSummaryText (digest, targetEn) {
      let text = `Target sentence: "${targetEn}"\n`;
      text += `Recognized:      "${digest.recognized || ''}"\n`;
      text += `Scores — overall:${digest.score} accuracy:${digest.accuracy} fluency:${digest.fluency} completeness:${digest.completeness} pronunciation:${digest.pronunciation} prosody:${digest.prosody}\n`;
      
      text += `Word issues:\n`;
      if (digest.weak_words && digest.weak_words.length > 0) {
        digest.weak_words.forEach(w => {
          text += `  - "${w.word}" ${w.error} (score ${w.score})\n`;
        });
      } else {
        text += `  - (none)\n`;
      }
      
      const prosodyStr = digest.prosody_issues && digest.prosody_issues.length > 0 
        ? digest.prosody_issues.join(', ') 
        : '(none)';
      text += `Prosody issues: ${prosodyStr}\n`;
      
      const currentRetry = this.aiCurrentTurn ? this.aiCurrentTurn.retry : 0;
      text += `Retry: ${currentRetry}`;
      
      return text;
    },

    _generateFallbackTips (digest) {
      const tips = [];
      if (digest.weak_words && digest.weak_words.length > 0) {
        tips.push(`請注意「${digest.weak_words.slice(0, 2).map(w => w.word).join('、')}」的發音。`);
      } else if (digest.score < 80) {
        tips.push("發音還可以更好，再試著清晰地念一次。");
      } else {
        tips.push("念得很棒！繼續保持。");
      }
      
      return {
        overall: '',
        tips: tips,
        highlight_words: digest.weak_words ? digest.weak_words.map(w => w.word) : []
      };
    }
  }
};